import {array, object, string} from "yup";

const generateFiltrationFormValidationSchema =
    (isManualLocationDefinitionMode: boolean) => (
        object({
            store_search_place: isManualLocationDefinitionMode ? object({
                label: string().required("Please enter a location."),
                value: string().required("Please enter a location.")
            }).required("Please enter a location.") : object().nullable().notRequired(),
            store_search_radius: object({
                label: string().required("Please enter a radius."),
                value: string().required("Please enter a radius.")
            }).required("Please enter a radius."),
            blj_store_locator_product_type: array().min(1, "Please select at least 1 product type").of(string().required()).required(),
        })
    );

export default generateFiltrationFormValidationSchema;